import { refreshAuthToken, latestAuthToken } from './auth/requestAuthTokenHandler';
import * as lokiContext from './lokiContext';
import { BootstrapperConfig, EnvironmentType } from './models/models';
import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function getLokiBootstrapperConfig(): BootstrapperConfig {
    if (!lokiContext.isInitialized) {
        throw new Error('You must call initializeLoki!');
    }
    const userConfig = getUserConfiguration();

    const config: BootstrapperConfig = {
        culture: lokiContext.culture,
        region: getLokiRegion(lokiContext.useDogfood, lokiContext.isMicrosoftUser),
        clientType: lokiContext.clientType,
        clientContextType: lokiContext.clientScenario,
        clientCorrelationId: lokiContext.clientCorrelationId,
        logMessage: (logType: string, logResultType: string, message?: string) => {
            lokiContext.log(logType, logResultType, message);
        },
        getAuthToken: refreshAuthToken,
        authToken: latestAuthToken,
        complianceEnvironment: getComplianceEnvironment(),
        isConsumer: lokiContext.isConsumer,
        tenantAadObjectId: userConfig.SessionSettings.ExternalDirectoryTenantGuid,
        userAadObjectId: userConfig.SessionSettings.ExternalDirectoryUserGuid,
        userPuid: userConfig.SessionSettings.UserPuid,
    };

    return config;
}

function getComplianceEnvironment(): EnvironmentType {
    if (isFeatureEnabled('lpc-isInBlackforest')) {
        return 'Blackforest';
    }

    if (isFeatureEnabled('lpc-isInGccModerate')) {
        return 'GccModerate';
    }

    return 'Prod';
}

function getLokiRegion(useLokiDogfood: boolean, isMicrosoftUser: boolean) {
    if (useLokiDogfood) {
        return 'df';
    }

    if (isMicrosoftUser) {
        return 'msit';
    }

    return '';
}
